/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const IS_SIDEBAR_NAVIGATION_MENU_ACTIVE = 'IS_SIDEBAR_NAVIGATION_MENU_ACTIVE';
